(function () {
  angular.module("akitabox.ui.components.floorCardContainer", [
    "akitabox.core.constants",
    "akitabox.core.services.floor",
    "akitabox.ui.components.floorCard",
  ]);
})();
